import type { EasyVrpMapContext } from './EasyVrpMapContext';
import type { Vehicle } from '../../Vehicles/Vehicle';
import { getJobLabel, getJobPin } from '../../Jobs/JobsOnMap';
import { EasyVrpMapPoint } from './EasyVrpMapPoint';
import { getContrastTextColor, LABEL_BORDER_COLOR } from './StyleUtils';

export class EasyVrpMapJobsManager {
    private mapElementIds: { id: string; x: number; y: number }[] = [];

    public clearMap() {
        console.log('#map Removing all jobs from map');
        this.mapElementIds.forEach(p => {
            Targeo.Base.Map.UORemove(p.id);
        });
        this.mapElementIds = [];
    }

    public addAssignedJobsToMap(
        mc: EasyVrpMapContext,
        selectedRouteId: string | null = null,
        display_order_on_map: boolean = true
    ): void {
        mc.getRouteIds().forEach(rid => {
            if (selectedRouteId !== null && rid !== selectedRouteId) {
                return; // Skip if not the selected vehicle
            }
            // const vehicle = mc.getContext().vehicles.find((v: Vehicle) => v.getId() === vehicleId);
            // let jobIds = mc.getContext().output.assigned[vehicleId].map(id => parseInt(id, 10));
            let points = mc.getPointsByRouteId(rid);
            let counter = -1;
            let color: string | undefined = mc.getColor(rid) ?? undefined;

            let startPoint = mc.getStartPoint(rid);
            if (startPoint) {
                const char = '•';
                let point = new Targeo.MapObject.Label({ x: startPoint.x, y: startPoint.y }, char, {
                    fs: 26,
                    fc: getContrastTextColor(color ?? '#ffffff'),
                    fm: { b: true },
                    bc: LABEL_BORDER_COLOR,
                    bw: 0,
                    bgc: 'transparent',
                });
                // console.log('#map Adding start point for vehicle', startPoint.x, startPoint.y);
                this.mapElementIds.push({ id: point.id, x: startPoint.x, y: startPoint.y });
                if (display_order_on_map) {
                    Targeo.Base.Map.UOAdd(point);
                }
            }

            let endPoint = mc.getEndPoint(rid);
            if (endPoint) {
                const char = '🏁';
                let point = new Targeo.MapObject.Label({ x: endPoint.x, y: endPoint.y }, char, {
                    fs: 13,
                    fc: getContrastTextColor(color ?? '#ffffff'),
                    fm: { b: true },
                    bw: 0,
                    bc: LABEL_BORDER_COLOR,
                    // bs: 'solid',
                    // br: 4,
                    // p: [0, 3, 0, 3],
                    bgc: 'transparent',
                });
                // console.log('#map Adding end point for vehicle', endPoint.x, endPoint.y);
                this.mapElementIds.push({ id: point.id, x: endPoint.x, y: endPoint.y });
                if (display_order_on_map) {
                    Targeo.Base.Map.UOAdd(point);
                }
            }

            points.forEach(p => {
                counter++;
                let pointId = 'job_' + p.id;
                // let point = new Targeo.MapObject.Point(
                //     { x: job.coordinates[1], y: job.coordinates[0] },
                //     getJobPin(vehicle?.getColor(), 40, { type: 'delivery' }, 'bold'),
                //     pointId,
                //     {
                //         name: getJobLabel(job),
                //         zIndex: 502,
                //         balloon: {
                //             width: 410,
                //             body: '<div class="lds-dual-ring-improved" style="width: 60px; height: 60px;"></div>',
                //         },
                //     }
                // );
                let point = new Targeo.MapObject.Label(
                    { x: p.coords[0], y: p.coords[1] },
                    // counter + '#' + p.id.toString(), // FIXME: should be a counter
                    counter.toString(), // + '#' + p.id.toString(), // FIXME: should be a counter
                    {
                        fs: 13,
                        fc: getContrastTextColor(color ?? '#ffffff'),
                        fm: { b: true },
                        bw: 1,
                        bc: LABEL_BORDER_COLOR,
                        bs: 'solid',
                        br: 4,
                        p: [0, 3, 0, 3],
                        bgc: color ?? '#98c8f8',
                    }
                );
                // console.log('#map Adding job point for vehicle', p.coords[0], p.coords[1]);
                this.mapElementIds.push({ id: point.id, x: p.coords[0], y: p.coords[1] });
                if (display_order_on_map) {
                    Targeo.Base.Map.UOAdd(point);
                }
            });
        });
    }

    public addUnassignedJobsToMap(mc: EasyVrpMapContext, display_order_on_map: boolean = true) {
        mc.getPointsWithoutVehicle().forEach(p => {
            let pointId = 'job_' + p.id;
            if (this.mapElementIds.find(id => id.id === pointId)) {
                console.warn('#map Job point already exists', pointId);
                return; // Skip if the point already exists
            }
            let point = new Targeo.MapObject.Label(
                { x: p.coords[0], y: p.coords[1] },
                p.id.toString(),
                {
                    fs: 13,
                    fc: getContrastTextColor('#cccccc'),
                    fm: { b: true },
                    bw: 1,
                    bc: '#333333',
                    bs: 'solid',
                    br: 4,
                    p: [0, 3, 0, 3],
                    bgc: '#cccccc',
                }
            );
            console.log('#map Adding unassigned job point', p.coords[0], p.coords[1]);
            this.mapElementIds.push({ id: point.id, x: p.coords[0], y: p.coords[1] });
            if (display_order_on_map) {
                Targeo.Base.Map.UOAdd(point);
            }
        });
        // return; // TODO: Implement this method if needed
        // let counter = 0;
        // mc.getUnassignedJobIds().forEach(jobId => {
        //     counter++;
        //     let job = mc.getContext().input.assignments.find(a => a.id === jobId);
        //     if (!job) {
        //         console.warn('Cannot find job id', jobId);
        //         return;
        //     }
        //     let point = new Targeo.MapObject.Label(
        //         { x: job.coordinates[1], y: job.coordinates[0] },
        //         counter.toString(),
        //         {
        //             fs: 13,
        //             fc: '#333333',
        //             fm: { b: true },
        //             bw: 1,
        //             bc: '#333333',
        //             bs: 'solid',
        //             br: 4,
        //             p: [0, 3, 0, 3],
        //             bgc: '#cccccc',
        //         }
        //     );
        //     this.mapElementIds.push(point.id);
        //     Targeo.Base.Map.UOAdd(point);
        // });
    }

    public addJobsToMap(
        mc: EasyVrpMapContext,
        uniqueRouteId: string | null = null,
        display_order_on_map: boolean = true
    ): void {
        this.addAssignedJobsToMap(mc, uniqueRouteId, display_order_on_map);
        if (uniqueRouteId === null) {
            this.addUnassignedJobsToMap(mc, display_order_on_map);
        }
    }

    public zoomToBounds(): void {
        if (this.mapElementIds.length === 0) {
            console.warn('#map No points to zoom to bounds');
            return;
        }
        // let bounds = { minX: 180, minY: 180, maxX: -180, maxY: -180 };
        let bounds = { minX: 180, minY: 180, maxX: -180, maxY: -180 };
        this.mapElementIds.forEach(point => {
            if (point.x > point.y) {
                console.warn('#map Invalid point coordinates', point);
            }
            bounds.minX = Math.min(bounds.minX, point.x);
            bounds.minY = Math.min(bounds.minY, point.y);
            bounds.maxX = Math.max(bounds.maxX, point.x);
            bounds.maxY = Math.max(bounds.maxY, point.y);
        });
        if (bounds) {
            console.log('#map Zooming to bounds', bounds);
            Targeo.Base.Map.zoomToBounds(bounds, false); // , [80, 120, 20, 180]
        }
    }
}
